import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PublicationViewStateRecord } from '@src/suite/common/data-models/records/publication-viewstate-record';
import { ViewStateRecord } from '@src/suite/common/data-models/records/viewstate-record';

export const CastActions = createActionGroup({
    source: 'Cast',
    events: {
        'Set Current Publication List Guid': props<{ guid: string }>(),
        'Set Current View State': props<{ guid: string }>(),
        'Set View States': props<{ viewStates: Array<ViewStateRecord> }>(),
        'Clear search term': emptyProps(),
        'Set side record guids': props<{ guids: Array<string> }>(),
        'Set drag record guid': props<{ guid: string }>(),
        'Stop drag': emptyProps(),
        'Set Processing': props<{ processing: boolean }>(),
        'Set Loading List': props<{ listLoading: boolean }>(),
        'Start Adding new section': props<{ position: number }>(),
        'Reset Adding new section': emptyProps(),
        'Stop Side Record Loading': emptyProps(),
    },
});

export const CastApiActions = createActionGroup({
    source: 'Cast',
    events: {
        'Load Publications channels': emptyProps(),
        'Load Publication List': props<{ vs: PublicationViewStateRecord; loadSpecificRevision?: boolean; setMaxPublicationRevisionNumber?: boolean }>(),
        'Load Records For Current Publication List': emptyProps(),
        'Load view states': emptyProps(),
        'Search Records': props<{ searchTerm: string }>(),
        'Reload Records For Selected View state': emptyProps(),
        'Add Update Publication List': props<{ droppedGuid: string }>(),
        'Delete Section': props<{ section: string }>(),
        'Delete Publications': props<{ publicationGuidsToDelete: Array<string> }>(),
        'Rename Publication list section': props<{ oldSection: string; newSection: string }>(),
        'Add Publication list section': props<{ section: string; idx: number }>(),
        'Add Publications to Publication List section': props<{ recordsToAdd: Array<string>; section: string }>(),
        'Clear Current Publication List': emptyProps(),
        'Publish current Publication List': emptyProps(),
        'Create new revision for current Publication List': emptyProps(),
    },
});
